import { fetchAuthSession } from "aws-amplify/auth";

/** Rejection value of getCurrentSession when nobody is signed in. */
export const NO_CURRENT_USER = "No current user";

/**
 * Returns the current Cognito session and rejects when nobody is signed in.
 * Amplify v6 resolves without tokens in that case, while v4's Auth.currentSession rejected;
 * RequireAuth and the API client rely on that rejection to send the user to the login.
 * @returns {Promise<import("aws-amplify/auth").AuthSession>}
 */
export async function getCurrentSession() {
  const session = await fetchAuthSession();
  if (!session.tokens?.idToken) {
    // Same plain-string rejection as v4: $log.error reports strings to GlitchTip as messages,
    // so the requests that fail right after a logout don't show up as exceptions.
    throw NO_CURRENT_USER;
  }
  return session;
}

/**
 * Returns the ID token sent as Bearer token to cytpanel.
 * @returns {Promise<string>}
 */
export async function getIdToken() {
  const { tokens } = await getCurrentSession();
  return tokens.idToken.toString();
}
